import React from 'react'
import FlexColContainer from '../../common/FlexColContainer'
import Card from '../../common/Card'
import Title from '../../common/Title'

export default function AdminPortfolioManagement() {
    return (
        <FlexColContainer>
            <Title title="Portfolio Management" />
            <Card>
                <div>Test</div>
                <div>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolores, aut inventore quasi dignissimos beatae placeat repudiandae quod aspernatur dolorem esse.</div>
            </Card>
        </FlexColContainer>
    )
}
